import {
  // getCopyWithContentTableColumn,
  getNameDescriptionTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn.js'
import { getStatusColumn } from '../utils'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        field: 'service_num',
        title: i18n.t('scope.text_778'),
        minWidth: 200,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.service_num}</side-page-trigger>
          )
        },
      }),
      {
        field: 'licensee',
        title: i18n.t('scope.text_318'),
        minWidth: 100,
        slots: {
          default: ({ row }, h) => {
            return [<list-body-cell-wrap copy row={row} field='licensee' title={row.licensee}>
              <a-button type="link" icon="filter" size="small" slot="appendActions" onClick={() => this.filterKey(row, 'licensee')} />
            </list-body-cell-wrap>]
          },
        },
      },
      {
        field: 'features',
        title: this.$t('scope.scene_type'),
        formatter: ({ cellValue }) => {
          if (!cellValue) return '-'
          return cellValue.includes('maintenance') ? this.$t('scope.technical_support') : this.$t('scope.auth')
        },
      },
      {
        field: 'used_for',
        title: i18n.t('scope.text_779'),
        minWidth: 120,
        formatter: ({ cellValue }) => {
          const map = {
            test: i18n.t('scope.commercial_evaluation'),
            community: i18n.t('scope.community'),
            internal: i18n.t('scope.internal_test'),
            commercial: i18n.t('scope.commercial_license'),
          }
          return map[cellValue]
        },
      },
      getStatusColumn(),
      {
        field: 'virt_arm_limit',
        title: i18n.t('scope.licenses.virthost_arm.title'),
      },
      {
        field: 'limit',
        title: i18n.t('scope.licenses.virthost.title'),
      },
      {
        field: 'server_limit',
        title: i18n.t('scope.licenses.cmp_server.title'),
      },
      {
        field: 'cmp_host_limit',
        title: i18n.t('scope.licenses.cmp_host.title'),
      },
      {
        field: 'baremetal_arm_limit',
        title: i18n.t('scope.licenses.baremetal_arm.title'),
      },
      {
        field: 'baremetal_limit',
        title: i18n.t('scope.licenses.baremetal.title'),
      },
      getTimeTableColumn({
        field: 'created_at',
        title: i18n.t('op_4'),
      }),
      getTimeTableColumn({
        field: 'expire',
        title: i18n.t('scope.text_780'),
        sortable: true,
      }),
      {
        field: 'licensor',
        title: i18n.t('common_610'),
        slots: {
          default: ({ row }, h) => {
            return [<list-body-cell-wrap copy row={row} field='licensor' title={row.licensor}>
              <a-button type="link" icon="filter" size="small" slot="appendActions" onClick={() => this.filterKey(row, 'licensor')} />
            </list-body-cell-wrap>]
          },
        },
      },
    ]
  },
  methods: {
    filterKey (row, key) {
      const obj = {
        ...this.list.filter,
      }
      obj[key] = [row[key]]
      this.list.changeFilter(obj)
    },
  },
}
